import { parse as parseYaml } from 'yaml'

// Match 0 includes the trailing newline, so `frontMatter + body` reproduces the input exactly.
const FRONT_MATTER_PATTERN = /^---\r?\n([\s\S]*?)\r?\n---(\r?\n|$)/

export interface SplitMarkdown {
  frontMatter: string | null
  body: string
}

// A leading `---` is equally a horizontal rule, so require the contents to parse as a YAML
// mapping. Guessing wrong hides real content from the editor.
function isYamlMapping(contents: string): boolean {
  if (contents.trim().length === 0) return false

  try {
    const parsed = parseYaml(contents)
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)
  } catch {
    return false
  }
}

export function splitFrontMatter(markdown: string): SplitMarkdown {
  const match = FRONT_MATTER_PATTERN.exec(markdown)

  if (!match || !isYamlMapping(match[1])) {
    return { frontMatter: null, body: markdown }
  }

  return { frontMatter: match[0], body: markdown.slice(match[0].length) }
}

export function joinFrontMatter(frontMatter: string | null, body: string): string {
  return frontMatter === null ? body : `${frontMatter}${body}`
}
